import React, { useEffect, useState, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { getProductList } from '../Services/ProductSearchService'
import SearchIcon from '@mui/icons-material/Search';
import { useTheme } from '@mui/material/styles';
import { useHistory } from 'react-router-dom';
import '../styles/sidebar.scss'
import { IconX, IconArrowRight } from '@tabler/icons-react';
import parse from 'html-react-parser';
import { getSearchHints } from '../Services/ProductSearchService'
import { debounce } from '@mui/material/utils'
import '../styles/searchbox.scss'
import { styled } from '@mui/system';
import { useMediaQuery, TextField, InputAdornment, CircularProgress,IconButton, Button, Tooltip, FormControlLabel,FormGroup, Autocomplete, Tab, Tabs, Box,Table, TableBody, TableFooter, TableCell, TableContainer, TableHead, TableRow, Paper, TablePagination, Pagination, Badge, Fab, Zoom, List, ListItem, ListItemIcon, ListItemText, Stack, Dialog, DialogActions, DialogContent, DialogTitle  } from '@mui/material';
import { useThemeManager } from '../Context/ThemeManager';
  
const SearchBox = (props) => {

  const { theme} = useThemeManager();
  const [suggests, setSuggest] = useState([]);
  const [hints, setHints] = useState([]);
  const [inputValue, setInputValue] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const history = useHistory();

  const handleInputChange = (event, newValue) => {
    const trimmedValue = newValue.trim(); //remove leading spaces
    setInputValue(newValue);
    setSearchHasValue(newValue);
    setSuggest([]);
    setHints([]);
    setIsLoading(true);
    if (trimmedValue.length >= 1) {
      debouncedFetchSuggestions(trimmedValue);
    }
    else{
      setIsLoading(false);
      setSuggest([]);
      setHints([]);
    }
  };

  const debouncedFetchSuggestions = useMemo(() =>
    debounce(async (value) => {
      if (!value){
       setIsLoading(false);
       setSuggest([]);
       setHints([]);
       return;
      }
      else{
          
            try {
              let mappedSuggests = [];

              if (value.length >= 3) {
                setIsLoading(true);
                const suggestData = await getProductList(value, false);
                mappedSuggests = suggestData?.map(items => ({
                  id: items.id,
                  type: items.type === 'molecule' ? 'Active Ingredients' : 'Products',
                  label: parse(items.productName),
                })) ?? [];
              }

              if (mappedSuggests.length > 0) {
                setSuggest(mappedSuggests);
                setHints([])
              } else {
                setIsLoading(true);
                const hintData = await getSearchHints(value);
                const mappedHints = hintData?.map(items => ({
                  id: items.id,
                  type: 'Did you mean?',
                  label: parse(items.productName),
                })) ?? [];
                setHints(mappedHints);
                setSuggest([]);
              }
            } catch (e) {
              console.error("Error fetching suggestions or hints", e);
            } finally {
              setIsLoading(false);
            }
      }
    }, 200), []
  );

  const handleManualSearchClick = () => {
    if (suggests.length > 0) {
      const selected = suggests[0]; // or use inputValue to match
      handleSearchNavigate(selected.type, selected.id, selected.label);
      if (props.handleCloseModal) props.handleCloseModal();
      handleClearInput();
      if (props.toggleDrawer) props.toggleDrawer(true);
    } else if (hints.length > 0) {
      const selected = hints[0]; // or use inputValue to match
      handleSearchNavigate(selected.type, selected.id, selected.label);
      if (props.handleCloseModal) props.handleCloseModal();
      handleClearInput();
      if (props.toggleDrawer) props.toggleDrawer(true);
    }
    else if (inputValue) {
      // Optional fallback if no suggestions match, but input exists
      console.log("No suggestion selected, raw input:", inputValue);
    }
  };

  const handleSearchNavigate = (types, id, label) => {
    const trimmedValue = inputValue.trim();

    // Sanitize label to avoid invalid %
    const safeLabel = label ? label.replace(/%/g, '%25') : '';

    if (types == 'prescriptions') {
      history.push('/dosingcalculations/' + id);
    } else if (types == 'Active Ingredients') {
      const encodedLabel = encodeURIComponent(safeLabel);
      history.push('/SearchResults/' + encodedLabel);
    } else if (types == 'Did you mean?') {
      const encodedLabel = encodeURIComponent(safeLabel);
      const encodedHints = encodeURIComponent(trimmedValue);
      history.push('/SearchResults/' + encodedLabel + '?hints=' + encodedHints);
    } else if (id === undefined) {
      history.push('/SearchResults?hints=' + encodeURIComponent(trimmedValue));
    } else {
      history.push('/ProductDetails/' + id);
    }
  };

  const handleClearInput = () => {
      setInputValue('');
      setSearchHasValue(false);
    };

  const [searchHasValue, setSearchHasValue] = React.useState(false);
  const makeAnimationStartHandler = (stateSetter) => (e) => {
    const autofilled = !!e.target?.matches("*:-webkit-autofill");
    if (e.animationName === "mui-auto-fill" || e.animationName === "mui-auto-fill-cancel") {
    stateSetter(autofilled || e.target.value !== '');
    }
  };
    
  const location = useLocation();
  const isHomePage = location.pathname === '/Home';
  const muiTheme = useTheme();
  const isLgScreen = useMediaQuery(muiTheme.breakpoints.up('lg'));
  // Custom Popper with full height on small screens
  const FullHeightPopper = styled('div')(({ theme }) => ({
    [`& .MuiAutocomplete-listbox`]: {
      // This fills remaining screen height from input down
      maxHeight: isHomePage ? 'calc(100dvh - 320px)' : 'calc(100dvh - 140px)', // Adjust 100px based on input position
      overflowY: 'auto',
    }
  }));

    return(
        <div id="searchContainer">
              <Autocomplete style={{marginTop: isLgScreen ? 16 : 12}}
                autoFocus
                autoHighlight
                freeSolo
                disableClearable
                disablePortal
                useStyles
                color="primary"
                filterOptions={(options)=> options}
                options={searchHasValue && inputValue.trim()? (suggests.length > 0 ? suggests : hints) : []}
                value={inputValue}
                groupBy={(option) => option.type}
                PopperComponent={!isLgScreen ? FullHeightPopper : undefined}
                renderGroup={(params)=>(
                  <li key={params.key} style={{marginLeft: 16, marginRight: 16}}>
                    <div style={{ marginTop: 4, fontSize: 12 }}>
                      {params.group === "Did you mean?" ? (
                        <span>
                          No suggestions found for <b style={{ wordBreak: 'break-all' }}>"{inputValue.trim()}"</b>.
                          <br/>
                          <b style={{ color: "#d32f2f", textTransform:"uppercase" }}>{params.group}</b>
                        </span>
                      ) : (
                        <b style={{ color: "#0262AB", textTransform:"uppercase" }}>{params.group}</b>
                      )}
                    </div>
                    <div className='list-items'>{params.children}</div>
                  </li>
                )}
                renderOption={(props, option) => {
                  const query = inputValue.trim();
                  const label = option.label || '';
                  if (!query) {
                    return <li {...props}>{label}</li>;
                  }
                  //console.log(label);
                  const index = label.indexOf(query);
                  

                  if (index === -1) {
                    return <li {...props}>{label}</li>;
                  }

                  return (
                    <li {...props}>
                      <span>
                        {label.substring(0, index)}
                        <span style={{fontWeight: 'bold' }}>
                          {label.substring(index, index + query.length)}
                        </span>
                        {label.substring(index + query.length)}
                      </span>
                    </li>
                  );
                }}
                loading={searchHasValue && isLoading}
                loadingText={
                  <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <CircularProgress size={16} />
                    Loading...
                  </span>
                }
                onChange={(event, newInputValue) => {
                  handleSearchNavigate(newInputValue.type, newInputValue.id, newInputValue.label)
                  if(props.handleCloseModal) props.handleCloseModal();
                  handleClearInput();
                  if(props.toggleDrawer) props.toggleDrawer(true);
                }}
                onInputChange={handleInputChange}
                sx={{
                  //width: { xs: 100, sm: 130, md: 150, lg: 170 },
                  // 👇 Select the hover item here
                  '& + .MuiAutocomplete-popper .MuiAutocomplete-option:active': {
                    // 👇 Customize the hover bg color here
                    backgroundColor: theme.primaryLight,
                  },
                  '& + .MuiAutocomplete-popper .MuiAutocomplete-option:hover': {
                    // 👇 Customize the hover bg color here
                    backgroundColor: theme.primaryLight,
                  },
                  '& + .MuiAutocomplete-popper .MuiAutocomplete-option.Mui-focused': {
                    backgroundColor: theme.primaryLight,
                  }
                }}
                renderInput={(params) => (
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <TextField
                      autoFocus
                      {...params}
                      label= {isLgScreen ? "Enter brand or ingredient name" : ""}
                      placeholder= {!isLgScreen ? "Enter brand or ingredient name" : ""}
                      variant="outlined"
                      fullWidth
                      className="searchTextField"
                      onKeyDown={(e) => {
                        if (isLoading && e.key === 'Enter') {
                          e.preventDefault(); // block enter during loading
                        }
                      }}
                      InputLabelProps={{ shrink: searchHasValue, sx: { fontWeight: 'bold' } }}
                      InputProps={{
                        ...params.InputProps,
                        startAdornment: (
                          <InputAdornment position="start" >
                            <SearchIcon sx={{ fontSize: 36, pl: '10px' }} />
                          </InputAdornment>
                        ),
                        endAdornment: (
                          <React.Fragment>
                            {inputValue && (<IconButton id="searchIcon" onClick={handleClearInput}> <IconX /> </IconButton>)}
                            <IconButton className="searchButton" 
                              sx={{
                                background: theme.buttonGradient,
                                "&:hover": {
                                  background: theme.buttonGradientHover
                                }
                              }} 
                              onClick={handleManualSearchClick}
                            >
                            {isLgScreen ? (
                              'Search'
                            ) : (
                              <IconArrowRight size={20}/>
                            )}
                          </IconButton>
                          </React.Fragment>
                        ),
                        onAnimationStart: makeAnimationStartHandler(setSearchHasValue),
                      }}
                    />
                  </div>
                )
                }
              />
        </div>
    )
};

export default SearchBox;